import { defineMessages } from 'react-intl';

export default defineMessages({
  procedureInformationTitle: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.title',
  },
  procedureNature: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  jurisdiction: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  courtFile: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.court_file.title',
  },
  isInsuredSued: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.is_insured_sued',
  },
  suedParties: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.suedParties',
  },
  yes: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.yes',
  },
  no: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.no',
  },
  packageContinuation: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.package_continuation',
  },
  edit: {
    id: 'legal_proceeding_page.judgement_add.procedure_information.edit',
  },
  assignedLawyerTitle: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  hearingDateTitle: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  hearingDateError: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.error',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
});
